var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckboxChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2768_11633)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    y: 0.7,
    width: 14.6,
    height: 14.6,
    rx: 2.3,
    fill: "#F4F1FE",
    stroke: "#6D51F6",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9865 5.00269C11.7315 5.00269 11.4645 5.08869 11.2695 5.28369L7.55955 9.03368C7.30255 9.29168 7.04454 9.24366 6.84254 8.94066L5.84556 7.44066C5.53956 6.98067 4.90055 6.85268 4.44255 7.15868C3.98455 7.46568 3.85654 8.10569 4.16154 8.56468L5.15956 10.0647C6.05955 11.4187 7.81556 11.5906 8.96256 10.4407L12.7036 6.72167C13.0926 6.33067 13.0926 5.67469 12.7036 5.28369C12.5086 5.08869 12.2415 5.00269 11.9865 5.00269Z",
    fill: "#6D51F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2768_11633"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/CheckboxChecked.ba96415077cc81d9d4e6752cbfdeffb8.svg";
export { ForwardRef as ReactComponent };